import { tt } from "../i18n/tt";
import { lazyI18n } from "../i18n/lazyText";
// 2026-08-30 전면 교체 — 등급 심볼을 크레스트 방패(A안)에서 "3D-2 보석 파셋"으로 바꾼다.
//
// 알파 UI 확정 패키지(브랜치 origin/claude/tier-system-ui-design-v692ou, PR #141)에서 반입 —
// 소스는 알파의 `docs/design/tier-ui-handoff.md`(정본 스펙 문서, 이 저장소엔 반입하지 않았다 —
// 수치만 이 파일과 `TierSymbol.jsx`/`colors.js`로 옮겨 담았다) 4절 "심볼 컴포넌트" + "등급 토큰".
//
// 원본은 등급을 영문 키(rookie/silver/gold/platinum/diamond/master)로 구분했지만, 이 저장소의
// 등급 정본은 `creatorTierNames.js`의 한글 명칭(`CREATOR_TIER_NAMES`)이다 — 새 영문 키 배열을
// 병행 도입하지 않고, 이 파일은 기존과 같은 한글 키로 심볼 전용 메타(면 개수·점선·링·폴백 글자)만
// 보관한다. 색은 `colors.js`의 `tier` 그룹(원본 그대로 영문 키, WCAG AA 검증값이라 값 자체를
// 바꾸지 않았다)에서 가져오며, 한글 등급명 → 그 영문 색 토큰 키 매핑은 `TIER_COLOR_KEY`가 맡는다.
//
// `TierSymbol`(../components/TierSymbol.jsx)이 이 메타를 읽어 6면 정육각형을 인라인 SVG로
// 직접 그린다(면을 채운 개수 = 등급 단계, WCAG 1.4.1 — 색만으로 정보 전달 금지). 24px 이하에서는
// 6면이 실제로 구분되지 않아(스펙 4절 "24px 이하 폴백") 컴포넌트가 자동으로 칩 배경 + `short`
// 한 글자로 전환한다.
export const TIER_SYMBOL_META = lazyI18n(() => ({
  루키: { facets: 0, dashed: true, short: tt("a.00583420", "루") },
  실버: { facets: 1, short: tt("a.f33638d0", "실") },
  골드: { facets: 2, short: tt("a.6d3bbfda", "골") },
  플래티넘: { facets: 3, short: tt("a.0f6e4562", "플") },
  다이아몬드: { facets: 4, short: tt("a.545f8368", "다") },
  // 마스터는 6면 전부 채우고, 다른 등급과 더 분명히 구분되도록 골드 외곽링을 추가로 두른다
  // (스펙 4절 "상태별 예외" — 링 색은 accent.500(#c2841a), colors.js 기존 토큰 재사용).
  마스터: { facets: 6, ring: true, short: tt("a.cde71a85", "마") },
}));

// 한글 등급명(또는 "루키") → colors.js `tier` 그룹의 영문 색 토큰 키.
export const TIER_COLOR_KEY = {
  루키: "rookie",
  실버: "silver",
  골드: "gold",
  플래티넘: "platinum",
  다이아몬드: "diamond",
  마스터: "master",
};
